import './edit-template';
import './duplicate-template';
import './restore-template';
import './archive-template';
import './delete-template';



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/workflows/details/index.js